import { format } from 'date-fns';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';

export const buildDateParams = (filters: IMainIndicatorsFilter): Record<string, string> => {
  const params: Record<string, string> = {};

  if (filters.dateFrom) {
    params.date_from = format(new Date(filters.dateFrom), 'yyyy-MM-dd');
  }

  if (filters.dateTo) {
    params.date_to = format(new Date(filters.dateTo), 'yyyy-MM-dd');
  }

  if (filters.accountStartedDateFrom) {
    params.account_started_date_from = format(
      new Date(filters.accountStartedDateFrom),
      'yyyy-MM-dd'
    );
  }

  if (filters.accountStartedDateTo) {
    params.account_started_date_to = format(new Date(filters.accountStartedDateTo), 'yyyy-MM-dd');
  }

  if (filters.clientStartedDateFrom) {
    params.client_started_date_from = format(new Date(filters.clientStartedDateFrom), 'yyyy-MM-dd');
  }

  if (filters.clientStartedDateTo) {
    params.client_started_date_to = format(new Date(filters.clientStartedDateTo), 'yyyy-MM-dd');
  }

  return params;
};
